import axios from 'axios'

function authHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchPartnerApplyStatus() {
  const res = await axios.get('/api/v1/partner/apply/status', { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || null
}

export async function submitPartnerApply(payload) {
  const res = await axios.post('/api/v1/partner/apply/submit', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '提交失败')
  return res.data.data
}

export async function submitWithdrawApply(payload) {
  const res = await axios.post('/api/v1/withdraw/apply/submit', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '提交失败')
  return res.data.data
}

export async function fetchWithdrawApplyList({ page = 1, pageSize = 20 } = {}) {
  const res = await axios.post('/api/v1/withdraw/apply/list', { page, pageSize }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function fetchMyCreations({ page = 1, pageSize = 20 } = {}) {
  const res = await axios.post('/api/v1/creator/my-creations', { page, pageSize }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { exams: [], courses: [], examTotal: 0, courseTotal: 0 }
}

export async function fetchCreatorIncome({ page = 1, pageSize = 20 } = {}) {
  const res = await axios.post('/api/v1/creator/income/list', { page, pageSize }, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function fetchUserMessages({ page = 1, pageSize = 20, source = '' } = {}) {
  const res = await axios.get('/api/v1/user/messages/list', {
    headers: authHeaders(),
    params: { page, pageSize, source: source || undefined, isRead: -1 }
  })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export function referralStatementExportUrl() {
  const token = localStorage.getItem('jwt_token')
  return `/api/v1/referral/export/statement?token=${encodeURIComponent(token || '')}`
}

export async function fetchAdminPartnerApplications(params) {
  const res = await axios.post('/api/v1/admin/partner/applications/list', params, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function reviewPartnerApplication(payload) {
  const res = await axios.post('/api/v1/admin/partner/applications/review', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '处理失败')
  return res.data.data
}

export async function fetchAdminWithdrawApplications(params) {
  const res = await axios.post('/api/v1/admin/withdraw/applications/list', params, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { items: [], total: 0 }
}

export async function reviewWithdrawApplication(payload) {
  const res = await axios.post('/api/v1/admin/withdraw/applications/review', payload, { headers: authHeaders() })
  if (res.data?.code !== 200) throw new Error(res.data?.message || '处理失败')
  return res.data.data
}

export function adminWithdrawExportUrl() {
  const token = localStorage.getItem('jwt_token')
  return `/api/v1/admin/withdraw/export?token=${encodeURIComponent(token || '')}`
}

export const PARTNER_STATUS_LABELS = {
  pending: '审核中',
  approved: '已通过',
  rejected: '已拒绝'
}

export const WITHDRAW_STATUS_LABELS = {
  pending: '待审核',
  approved: '已通过待打款',
  rejected: '已拒绝',
  paid: '已打款'
}
